import React from 'react';

export const renderAdditionalMapBtns = (
	handleZoomToSite,
	handleUndoAOIChanges,
	drawing,
	updateSite
) => {
	const SHARED_PROPS = {
		left: '28px',
		border: 'none',
		borderRadius: '3px',
		zIndex: '1',
		height: '30px',
		width: '30px',
		padding: '3px',
		boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.1)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		display: 'inline-block',
		cursor: 'pointer',
		backgroundColor: '#f8f9fa',
		color: 'black',
		textAlign: 'center'
	};

	const STYLE_RECENTER = {
		position: 'absolute',
		top: '125px',

		...SHARED_PROPS
	};

	const STYLE_UNDO = {
		position: 'absolute',
		top: '165px',
		...SHARED_PROPS
	};

	return (
		<>
			<div
				style={STYLE_RECENTER}
				onClick={() => handleZoomToSite(drawing.drawLat, drawing.drawLong, 13)}
				id="recenterMapBtn"
			>
				<label title="Recenter map">
					<i className="fa-solid fa-location-crosshairs"></i>
				</label>
			</div>

			<div
				style={STYLE_UNDO}
				onClick={() => (updateSite ? handleUndoAOIChanges() : undefined)}
				disabled={!updateSite}
				id="undoDrawChangesBtn"
			>
				<label title="Reset AOI to original">
					<i className="fa-solid fa-arrow-rotate-left"></i>
				</label>
			</div>
		</>
	);
};
